import { Box, TextNew } from '@jfs/ui-new'
import { styles } from './styles'

export const FlatListHeader = ({ headerTitles, columnFlexMapper, type = 'default' }: any) => {
  const isEmi = type === 'EMI' || type === 'dropdown'
  return (
    <Box {...styles.flatListHeader}>
      {headerTitles?.map((item, index: number) => {
        return (
          <Box flex={columnFlexMapper[index] ?? 1} pv={12} justify={isEmi ? 'center' : undefined} ph={4} key={index}>
            <TextNew title={item?.title} {...styles.keyText} textAlign={isEmi ? 'left' : undefined} />
          </Box>
        )
      })}
    </Box>
  )
}
